import en from "./en.i18n";

export default {
  en,
};
